import React from 'react';
import queryString from 'query-string';
import { BiHome } from 'react-icons/bi';
import { toastError } from 'react-geek-toast';
import Splash from 'partial/containers/Splash';
import { useHistory, useLocation } from 'react-router-dom';

import Button from 'partial/components/Button';
import Version from 'partial/components/Version';
import { SolidLogo } from 'modules/common/components/AppIconLogo';
import IconCheckSuccess from 'assets/images/icons/icon-check-success.svg';
import IconInvalidExpired from 'assets/images/icons/icon-invalid-activation.svg';

import NewPasswordForm from '../forms/NewPasswordForm';
import { useValidateForgotPassword } from '../hooks';

function ForgotPassword() {
  const history = useHistory();
  const location = useLocation();
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [validate, isValidating] = useValidateForgotPassword();
  const [isInvalid, setIsInvalid] = React.useState(true);
  const handleBackToHomePage = () => history.push('/');

  React.useEffect(() => {
    if (queryString.parse(location?.search)?.token) {
      validate(
        { token: queryString.parse(location?.search)?.token },
        () => setIsInvalid(false),
        () => {
          toastError('Reset Password Link is Invalid');
          setIsInvalid(true);
        }
      );
    }
  }, [validate, location]);

  if (isValidating) {
    return <Splash />;
  }

  if (!isValidating) {
    if (isInvalid) {
      return <InvalidForgotPassword />;
    }
  }

  return (
    <div className="h-screen flex flex-col bg-gradient-to-t from-primary-700 to-primary-800">
      <div className="h-screen flex flex-col items-center justify-center bg-dotted-effect bg-login relative">
        {!isSuccess && !isInvalid && (
          <div className="absolute top-5 left-5 uppercase">
            <Button outlineLight icon={BiHome} onClick={handleBackToHomePage}>
              Back to homepage
            </Button>
          </div>
        )}
        <div className="flex justify-center h-40 relative">
          <SolidLogo className="h-40" />
          <p className="absolute bottom-9 ml-20 text-xs text-white whitespace-nowrap">
            BILLER PORTAL
          </p>
        </div>
        <main className="mt-8 mx-2 flex flex-col items-center bg-white rounded-2xl p-4 sm:p-6 lg:p-10 w-full max-w-xl">
          {isSuccess ? (
            <ChangePasswordSuccess />
          ) : (
            <>
              {!isInvalid ? (
                <>
                  <h1 className="text-center text-2xl mb-6 font-semibold">
                    Reset Password
                  </h1>
                  <NewPasswordForm onSuccess={setIsSuccess} />
                </>
              ) : null}
            </>
          )}
        </main>
        <div className="text-xs font-light mt-10 text-center text-gray-400">
          &copy; 2021 DST Biller Portal <Version />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;

function ChangePasswordSuccess() {
  const history = useHistory();
  const handleBackToHomePage = () => history.push('/');
  return (
    <>
      <img src={IconCheckSuccess} alt="icon-check-success" className="w-36" />
      <div className="border-b text-center mt-4 pb-4 px-4">
        <h1 className="text-xl font-semibold">Reset Password Successful</h1>
        <p className="text-gray-500 mt-2">
          You have successfully updated your password.
        </p>
      </div>
      <Button
        outlinePrimary
        type="button"
        onClick={handleBackToHomePage}
        className="mt-6 w-60 h-14"
      >
        Back to Hompage
      </Button>
    </>
  );
}

function InvalidForgotPassword() {
  const history = useHistory();
  const handleBackToHomePage = () => history.push('/');
  return (
    <div className="h-full flex flex-col bg-gradient-to-t from-primary-700 to-primary-800">
      <div className="h-full flex flex-col bg-center bg-login">
        <div className="w-full max-w-lg m-auto">
          <div className="flex justify-center mb-6 h-40 relative">
            <SolidLogo />
            <p className="absolute bottom-9 left-60 ml-4 text-xs text-white whitespace-nowrap">
              BILLER PORTAL
            </p>
          </div>
          <div className="m-auto w-full px-14 pb-10 pt-14 rounded-none sm:rounded-3xl bg-white">
            <div className="flex flex-col items-center border-b border-gray-200 pb-6 mb-6">
              <img
                src={IconInvalidExpired}
                alt="expired"
                className="w-36 mb-6"
              />
              <h1 className="text-center text-xl mb-2 font-semibold">
                Reset Password Invalid
              </h1>
              <p className="text-center text-sm text-gray-500 mb-6">
                The reset password link has already been expired and no longer
                valid.
              </p>
              <p className="text-center text-sm text-gray-500">
                You may request another by going back to login page and then
                click forgot password.
              </p>
            </div>
            <div className="flex justify-center">
              <Button outlinePrimary onClick={handleBackToHomePage}>
                Back to Login
              </Button>
            </div>
          </div>
          <p className="text-white text-xs text-center mt-6">
            &copy; 2021 DST Biller Portal <Version />
          </p>
        </div>
      </div>
    </div>
  );
}
